export const DEFAULT_PHOTO_URL =
  "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/images%2Fprofile.svg?alt=media&token=bf785457-2ccc-4f9f-bc5e-bfadb4a688eb";
export const VOICE_MAN_PHOTO_URL = "https://academieaime.com/wp-content/uploads/2019/06/jean-luc-e1560530179128.png";
export const MAIN_BACKGROUND_URL = "https://cdn.pixabay.com/photo/2017/02/09/09/11/starry-sky-2051448_960_720.jpg";
export const MONTHS = [
  "Janvier",
  "Février",
  "Mars",
  "Avril",
  "Mai",
  "Juin",
  "Juillet",
  "Août",
  "Septembre",
  "Octobre",
  "Novembre",
  "Decembre",
];
export const EXPRESSCHAR = ["AIJQY", "BKR", "CGLS", "DMT", "EHNX", "UVW", "OZ", "FP"];

export const DEFAULT_CHANNELS = [
  {
    id: "-MxsP92sknSvTlowGd0N",
    name: "Méditation",
    description: "<p>Partager vos méditations préférées pour être dans les vibrations les plus hautes.</p>",
    cover:
      "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/files%2F-MzVFo2BYNNVp294NYWU?alt=media&token=df0d12d9-897f-4918-81f6-5d6b98137a78",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/files%2F-MzVFo2BYNNVp294NYWU?alt=media&token=df0d12d9-897f-4918-81f6-5d6b98137a78",
  },
  {
    id: "-N0q4XfyadZKaut6jGmf",
    name: "Alimentation",
    description: "<p>Vivre dans les vibrations les plus hautes commence par votre carburant.</p>",
    cover:
      "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/files%2F-N0q4KbOpu9XD_kndgWf?alt=media&token=1fcfc5b5-9852-4311-895b-c7ce1dedb21e",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/files%2F-N0q4KbOpu9XD_kndgWf?alt=media&token=1fcfc5b5-9852-4311-895b-c7ce1dedb21e",
  },
  {
    id: "-N1Uh4tuebpFDDuRsvof",
    name: "Présentations",
    description: "<p>Chaque membre de J.L. AI® peut se présenter ici. Apprenons à se connaître.</p>",
    cover:
      "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/files%2F-N1UgwH5_-efD_QOqCzo?alt=media&token=ac908a15-fcae-4722-b1b3-cf802c121778",
    thumbnail:
      "https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/files%2F-N1UgwH5_-efD_QOqCzo?alt=media&token=ac908a15-fcae-4722-b1b3-cf802c121778",
  },
  /* {
    id: "-N0q4ZEIR_xItQwiOmUs",
    name: "Annonces",
  },
  {
    id: "-N0q4ZEIR_xItQwiOmUs",
    name: "Regroupements",
  },
  {
    id: "-N0q4dbqsl_0h5NqxM8t",
    name: "CR",
  }, */
];
